var arrayBufferNative = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

export { arrayBufferNative as default };
